import { Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-autocomplete-field-mapper',
  templateUrl: './autocomplete-field-mapper.component.html',
  styleUrl: './autocomplete-field-mapper.component.css',
  providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AutocompleteFieldMapperComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class AutocompleteFieldMapperComponent implements OnInit, ControlValueAccessor{
  @Input() options: string[] = []; // Options for the autocomplete
  @Input() disabledColumnsMap: Map<string, string[]> = new Map(); 
  @Input() nodeID: string = "";
  @Input() nodeColor: string = "";
  @Input() placeholder: string = "";
  @Output() selectionChange = new EventEmitter<string>(); // Emits the selected option
  @Output() moveToNextField = new EventEmitter<'forward' | 'reverse'>();   // Emits when Enter or Tab is pressed
  @Input() tabIndex: number = 0;
  @Input() colorcode: string = "";
  @ViewChild('inputElement') inputElement!: ElementRef<HTMLInputElement>;
  @ViewChild('fakeclick') fakeclick!: ElementRef<HTMLInputElement>;

  formControl = new FormControl('');
  filteredOptions!: Observable<string[]>;
  optionsfilter: string[] = [];
  disabledColumns: string[] = []; 
  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  ngOnInit() {
    // Initialize filtering logic
    this.filteredOptions = this.formControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    );

    // Emit changes to ngModel whenever the form control value changes
    this.formControl.valueChanges.subscribe(value => {
      this.onChange(value);
      this.onTouched();
    });
  }
  ngOnChanges(changes: any): void {
    setTimeout(() => {
      this.getOptions();
    }, 100);
  }
  // Write a new value to the element
  writeValue(value: any): void {
    this.formControl.setValue(value, { emitEvent: false });
  }

  // Set the function to be called when the control receives a change event
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  // Set the function to be called when the control receives a touch event
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  // Private method to filter options based on input value
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    //return this.options.filter(option => option.toLowerCase().includes(filterValue));//regular one
    // Filter options that match starting characters
    const startsWithMatches = this.optionsfilter.filter(option => 
      option.toLowerCase().startsWith(filterValue)
    );

    // Filter options that contain the value anywhere
    const containsMatches = this.optionsfilter.filter(option => 
      !option.toLowerCase().startsWith(filterValue) && option.toLowerCase().includes(filterValue)
    );

    // Combine results: prioritize starting matches
    return [...startsWithMatches, ...containsMatches];

  }
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === 'Tab') {
      const currentValue = this.formControl.value;
      if (event.shiftKey && event.key === 'Tab') {
        // Logic for Shift + Tab (reverse tabbing)
        event.preventDefault();
        this.inputElement.nativeElement.blur();
        this.fakeclick.nativeElement.click(); // For legacy issue
        this.moveToNextField.emit('reverse'); // Emit a reverse navigation event
      } else {
        if(currentValue===""){
          event.preventDefault();
          this.inputElement.nativeElement.blur();
          this.fakeclick.nativeElement.click();//for legacy issue if remove legacy this.autocompleteTrigger.closePanel(); 
          this.selectionChange.emit('');
          this.moveToNextField.emit('forward');
        }else{
          if (!this.options.includes(currentValue)) {
            this.formControl.setValue(''); // Clear the input if the value is invalid
          }else{
            event.preventDefault();
            this.inputElement.nativeElement.blur();
            this.fakeclick.nativeElement.click();
            this.moveToNextField.emit('forward');
          }
        }
      }
    }
  }
  onOptionSelected(option: string) {
    this.selectionChange.emit(option); // Emit selected option
  }
  validateSelection(): void {
    const currentValue = this.formControl.value;
    setTimeout(() => {
      const currentValue = this.formControl.value;
      if (!this.optionsfilter.includes(currentValue)) {
          this.formControl.setValue('Not Mapped'); // Clear the input if the value is invalid
      }
      this.selectionChange.emit(currentValue);
    }, 500);
  }
  getOptions(){
    const currentValue = this.formControl.value;
    if(currentValue!=""){
      this.disabledColumns=this.disabledColumns.filter(column => column !== currentValue);
    }
    this.optionsfilter= [...this.options.filter(col => !this.disabledColumns.includes(col))];
    // Recalculate filtered options if needed
    this.filteredOptions = this.formControl.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value || ''))
    );
  }
  disabledMapToFields:any
  isOptionDisabled(nodeID:string,item: string): boolean {
    //console.log(nodeID,item)
    this.disabledMapToFields = new Set(this.disabledColumnsMap.get(nodeID));
    //console.log('isOptionDisabled value: ', this.disabledMapToFields );
    return this.disabledMapToFields.has(item);
  }
}
